module.exports = __webpack_public_path__ + "static/media/img1.06dc3c85.jpeg";